import { useState } from 'react'
import { useDisclosure } from '@mantine/hooks'
import { DEFAULT_PLANNER_CONTROL_SCHEMA, type PlannerControlSchema } from './schemaSwitch'

export function usePlannerDisplaySettings() {
  const [drawerOpen, drawerHandlers] = useDisclosure(false)
  const [displayAllNodes, setDisplayAllNodes] = useState(true)
  const [displayOffNetworkNodes, setDisplayOffNetworkNodes] = useState(false)
  const [displaySignPosts, setDisplaySignPosts] = useState(false)
  const [displayParkingAreas, setDisplayParkingAreas] = useState(false)
  const [displayNodeNumbers, setDisplayNodeNumbers] = useState(true)
  const [displayLegend, setDisplayLegend] = useState(false)
  const [controlDataSchema, setControlDataSchema] = useState<PlannerControlSchema>(DEFAULT_PLANNER_CONTROL_SCHEMA)

  return {
    drawerOpen,
    drawerHandlers,
    displayAllNodes,
    setDisplayAllNodes,
    displayOffNetworkNodes,
    setDisplayOffNetworkNodes,
    displaySignPosts,
    setDisplaySignPosts,
    displayParkingAreas,
    setDisplayParkingAreas,
    displayNodeNumbers,
    setDisplayNodeNumbers,
    displayLegend,
    setDisplayLegend,
    controlDataSchema,
    setControlDataSchema,
  }
}
